import {Typography} from "@mui/material"
import Grid from "@mui/material/Grid"
import {Trans, useTranslation} from "react-i18next"

import {Page} from "@indebted/components/Page"

function ScrubDetected() {
	const {t} = useTranslation()
	return (
		<Page>
			<Grid>
				<Typography align="center" variant="h6">
					{t("customer_get.scrub_detected.title")}
				</Typography>
			</Grid>

			<Grid>
				<Typography align="center" className="amp-mask">
					<Trans i18nKey="customer_get.scrub_detected.message" />
				</Typography>
			</Grid>
		</Page>
	)
}

export {ScrubDetected}
